module.exports = __webpack_public_path__ + "img/kaishi.308ed461.png";